import QueueLink from 'apollo-link-queue';
import { createHttpLink } from 'apollo-link-http';
import { ApolloClient } from 'apollo-client';
import { ApolloLink } from 'apollo-link';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { RetryLink } from 'apollo-link-retry';
import { DocumentNode } from 'graphql';
import fetch from 'unfetch';

export const offlineLink = new QueueLink();

window.addEventListener('offline', () => offlineLink.close());
window.addEventListener('online', () => offlineLink.open());

export const createQueryAndMutateFunctions = (url: string | undefined, authLink: ApolloLink) => {
  const httpLink = createHttpLink({
    uri: url,
    fetch,
  });

  const apiLink = ApolloLink.from([new RetryLink(), offlineLink, authLink, httpLink]);

  const apolloClient = new ApolloClient({
    link: apiLink,
    cache: new InMemoryCache(),
    connectToDevTools: true,
    defaultOptions: {
      query: {
        fetchPolicy: 'no-cache',
      },
    },
  });

  const query = async (
    queryString: DocumentNode,
    variables?: { [key: string]: any },
  ): Promise<any> => {
    return apolloClient.query<any>({ query: queryString, variables });
  };

  const mutate = async (
    mutation: DocumentNode,
    variables?: { [key: string]: any },
  ): Promise<any> => {
    return apolloClient.mutate<any>({ mutation, variables });
  };

  return { query, mutate };
};
